// AOS Animations
import AOS from 'aos';
AOS.init({
    offset: 100,
    duration: 600,
    delay: 100,
});

// Other
import "/src/style/main.scss"

// Modules
import Cards from './scripts/modules/cards'
Cards().init()

import Navigation from './scripts/modules/navigation'
Navigation().init()

import GoogleMap from "./scripts/modules/google-map";
GoogleMap().init()

import Accordions from "./scripts/modules/accordions";
Accordions().init()